import { Injectable, inject } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import {
  NewGroupDialogComponentData,
  NewGroupDialogComponent,
} from '@shared/new-group-dialog/new-group-dialog.component'

@Injectable()
export class NewPreferenceDialogService {
  dialog = inject(MatDialog)

  open(portfolioName: string) {
    const data: NewGroupDialogComponentData = {
      groupName: portfolioName,
      pageName: 'View',
    }
    return this.dialog.open(NewGroupDialogComponent, {
      width: '35vw',
      data,
    })
  }
}
